<h2 mat-dialog-title class="preserve-newlines">{{ data.title }}</h2>

<mat-dialog-content class="preview-content">
  <div class="image-wrapper">
    <img [src]="data.imageSrc" [alt]="data.imageAlt" draggable="false" />
    @if (data.canDelete) {
      <button mat-icon-button class="delete-button" (click)="onDelete()" [title]="translateService.instant('liveforms-editor.common.buttons.delete')">
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
</mat-dialog-content>
